import { create } from '~/utils/store/createStore';

export const HISTORY_SIDEBAR_CATEGORIES = [
  'all',
  'bookmarked',
  'scheduled',
] as const;
export type CategoryType = (typeof HISTORY_SIDEBAR_CATEGORIES)[number];

// ponytail: a trimmed-down stand-in for web-app's useHistorySidebarNavigation
// store - lseg doesn't have the settings-page/query-param-driven navigation
// this depends on, so this only tracks what the scheduled-queries feature
// needs: which task is selected, and which history-sidebar tab is active.
interface ScheduledTaskViewState {
  selectedScheduledQueryId: string | null;
  category: CategoryType;
  pendingRunTaskId: string | null;
}

interface ScheduledTaskViewActions {
  setSelectedScheduledQueryId: (id: string | null) => void;
  setCategory: (category: CategoryType) => void;
  setPendingRunTaskId: (id: string | null) => void;
}

type ScheduledTaskViewStore = ScheduledTaskViewState & ScheduledTaskViewActions;

export const useScheduledTaskView = create<ScheduledTaskViewStore>(set => ({
  selectedScheduledQueryId: null,
  category: 'all',
  pendingRunTaskId: null,
  setSelectedScheduledQueryId: id => set({ selectedScheduledQueryId: id }),
  setCategory: category => set({ category }),
  setPendingRunTaskId: id => set({ pendingRunTaskId: id }),
}));
